import * as React from 'react';
import * as classNames from 'classnames';

import * as styles from './RecommendationSkeleton.css';

export const RecommendationSkeleton: React.FC = () => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  // На случай, если в iOS браузере не поддерживается background-attachment: fixed;
  React.useLayoutEffect(() => {
    const el = containerRef.current;
    if (el) {
      el.style.setProperty('--left-offset', `${el.getBoundingClientRect().left}px`);
    }
  }, []);

  return (
    <div ref={containerRef} className={styles['container']}>
      <div className={classNames(styles['skeleton'], styles['image'])} />
      <div className={classNames(styles['skeleton'], styles['description'])} />
    </div>
  );
};
